"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
function default_1({ category_id, category_name, maxWidth768, }) {
    let categoryName = '';
    if (category_name) {
        categoryName = category_name;
    }
    else {
        switch (category_id) {
            case 'STORY_CATEGORY_00':
                categoryName = '연성';
                break;
            case 'STORY_CATEGORY_01':
                categoryName = '질문함';
                break;
            case 'STORY_CATEGORY_02':
                categoryName = '정보';
                break;
            case 'STORY_CATEGORY_03':
                categoryName = '후기';
                break;
            case 'STORY_CATEGORY_04':
                categoryName = '롤링페이퍼';
                break;
        }
    }
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
            position: 'absolute',
            bottom: 0,
            width: '100%',
            padding: '4px',
            borderRadius: '0px 0px 15px 15px',
            backgroundColor: 'rgba(0, 0, 0, 0.7)',
            textAlign: 'center',
            fontSize: maxWidth768 ? '12px' : '13px',
            color: 'white',
        } }, { children: t(categoryName) })));
}
exports.default = default_1;
